// External Dependencies:
import React from 'react'
import { Link } from 'react-router-dom'

// Internal Dependencies:
import Editable from 'church-theme-library/components/Editable/Editable'
import { get } from 'church-theme-library/utilities/objects'
import Image from 'church-theme-library/components/Image/Image'
import ImageOverlay from 'church-theme-library/components/Image/ImageOverlay'

class PullquoteImage extends React.Component {
	render() {
		const { contentId, sectionId, data } = this.props

		if ( ! data ) {
			return null
		}

		const style = get( ['settings', 'style'] )( data, '' )
		const className = `section-pullquote-image -style-${style}`

		const fullData = {
			image: data.image || {
				url: '',
				alt: '',
				aspect_ratio: '',
				focal_point: '',
				width: '',
				height: '',
				thumb: '',
				srcset: ''
			},
			content: data.content || ''
		}

		return (
			<div className={ className }>
				<div className="-inner">
					<div className="-text">
						<Editable
							element="h2"
							id={ contentId }
							sectionId={ sectionId }
							sectionType={ data.type }
							sectionDataId="content"
							content={ fullData.content }
						/>
					</div>

					<ImageOverlay imageData={ fullData.image } />

					<Editable
						id={ contentId }
						sectionId={ sectionId }
						sectionType={ data.type }
						sectionDataId="image"
						className="-image"
					>
						<Image
							thumb={ fullData.image.thumb }
							thumbWebp={ fullData.image.thumb_webp }
							url={ fullData.image.url }
							srcset={ fullData.image.srcset }
							srcsetWebp={ fullData.image.srcset_webp }
							sizes={ `(max-width: ${siteData.mobile_max_width}px) 100vw, 1100px` }
							alt={ fullData.image.alt }
							focalPoint={ fullData.image.focal_point }
							width={ fullData.image.width }
							height={ fullData.image.height }
						/>
					</Editable>
				</div>
			</div>
		)
	}
}

export default PullquoteImage
